import React from 'react';
import { TabBox } from "./TabBox";
import { CalendarBox } from "./CalenderBox";
import { MealBox } from "./MealBox"
import "./release1.less"
import { FoodModel } from './foodModel';
export function Release() {
    return (
        <>
            <TabBox />
            <div style={{ marginTop: "15px", display: "flex" }} className="release1">
                <CalendarBox />
                <MealBox />
                <FoodModel/>
            </div>
        </>
    );
}


